import { z } from "zod";
// Codici d'errore dell'API (piano M1a Task 8): il client decide che cosa mostrare leggendo il codice,
// mai il messaggio, che resta un testo tecnico in inglese. `details` porta i dati aggiuntivi di alcuni
// errori (per esempio lo stato di un'appartenenza già esistente o l'invito in attesa), mai segreti.
export const API_ERROR_CODES = [
    "google_calendar_unavailable",
    "google_oauth_invalid",
    "google_calendar_failed",
    "billing_unavailable", "registration_unavailable", "registration_token_invalid", "billing_payment_required", "billing_seat_limit", "billing_signature_invalid",
    "unauthenticated",
    "membership_required",
    "membership_forbidden",
    "platform_forbidden",
    "organization_unavailable",
    "organization_schema_outdated",
    "permission_denied",
    "protected_owner",
    "role_level",
    "slug_taken",
    "provisioning_failed",
    "provisioning_unavailable",
    "invitation_invalid",
    "invitation_expired",
    "invitation_revoked",
    "invitation_used",
    "invitation_pending",
    "already_member",
    "invalid_credentials",
    "role_in_use",
    "system_role",
    "feature_unavailable",
    "cannot_act_on_self",
    "not_found",
    "validation_failed",
    "invalid_state",
    "rate_limited",
    "session_mismatch",
    "role_name_taken",
    "origin_forbidden",
    "payload_too_large",
    "internal_error",
    // Lead (piano M2, Task 6 e seguenti)
    "lead_not_found",
    "version_conflict",
    "field_not_editable",
    "invalid_field_value",
    "invalid_phone",
    "phone_required",
    "phone_in_use",
    "phone_repeated_on_lead",
    "possible_duplicate_email",
    "reason_required",
    "owner_not_eligible",
    "call_not_found",
    "card_model_invalid",
    "import_run_not_found",
    // Una ricerca salvata di Close che la verifica del passaggio non conosce, o che è già diventata una Smart List (INGR-28)
    "saved_search_not_found",
    // Vista Commerciale e Lead di chi viene sospeso (piano M2, Task 10)
    "commercial_view_denied",
    "membership_active",
    "membership_has_leads",
    // Una persona nata sospesa da Close torna soltanto con un invito (INGR-15)
    "membership_from_close",
    // Filtri dell'elenco Lead e delle Smart List (piano M3, Task 1 e 3)
    "filter_invalid",
    // Smart List (piano M3, Task 7)
    "smart_list_not_found",
    "smart_list_name_taken",
    "tag_name_invalid",
    "tag_hidden",
    "recipients_required",
    // Archivio dei Lead (piano M3, Task 11)
    "lead_archived",
    "lead_not_archived",
    "lead_merged",
    "confirmation_required",
    // Azioni multiple (piano M3, Task 13)
    "bulk_too_large",
    // «Pulizia dati»: unione dei doppioni (piano M3, Task 16)
    "merge_invalid",
    // La telefonia di un'azienda (piano M4, Task 5): la connessione non è pronta, manca la chiave di piattaforma, un passo
    // del provisioning presso il fornitore non è riuscito.
    "telephony_unavailable",
    "telephony_provisioning_unavailable",
    "telephony_provisioning_failed",
    // Le chiamate della telefonia (piano M4, Task 8): il Lead o il telefono non si chiamano (con il motivo), un collega è già
    // al telefono con il Lead, il numero non è fra quelli che l'azienda di prova può chiamare.
    "lead_not_callable",
    "lead_in_call",
    "destination_not_allowed",
    // L'esito della chiamata (piano M4, Task 10): la chiamata ne ha già uno, e quello nuovo resta come esito arrivato tardi.
    "call_outcome_exists",
    // L'ascolto di una registrazione (piano M4, Task 11a; dal 4 ottobre 2026 dall'audio presso il fornitore): l'audio adesso non si
    // raggiunge (il fornitore non risponde come deve, o lo spazio europeo dell'audio già copiato non è configurato); il gettone
    // dell'indirizzo per ascoltare è scaduto, e se ne chiede un altro.
    "recording_unavailable",
    "recording_link_expired",
    // Un allegato di una nota di Close copiato in Gioia365 (INGR-27): adesso non si raggiunge (l'archivio non è configurato o non
    // risponde); il gettone dell'indirizzo è scaduto, e se ne chiede un altro.
    "attachment_unavailable",
    "attachment_link_expired",
    // «Elimina per sempre» di un Lead (piano M4, Task 11a): l'audio delle sue registrazioni non si è potuto togliere.
    "lead_audio_not_deleted",
    // Il Power Dialer (piano M5, Task 3): chi chiede ha già una sessione attiva o in pausa (con la sua sorgente); la sessione non
    // c'è, è di un'altra persona o non c'è una sessione interrotta da riprendere; la sorgente non ha nessun Lead da chiamare;
    // il Lead aperto ha una chiamata di chi chiama senza esito o ancora in corso; il Lead è riservato da un collega nella sua
    // sessione (con il suo nome).
    "dialer_session_active",
    "dialer_session_not_found",
    "dialer_source_empty",
    "dialer_outcome_missing",
    "dialer_call_in_progress",
    "lead_reserved",
    // I Lead ancora da chiamare li sta cambiando in questo momento un'altra scrittura (un'azione multipla, un'unione), oppure i
    // primi 200 candidati provati si saltano tutti e altri restano da provare: l'avvio o la ripresa della sessione si riprova fra un
    // attimo (ruling Q28).
    "dialer_queue_busy",
    // «Salta» dopo una chiamata del Lead nella sessione (si passa oltre con «Lead successivo»); la sessione è in pausa, e
    // l'avanzamento, il salto e una chiamata con quella sessione aspettano «Riprendi» (piano M5, Task 4).
    "dialer_already_called",
    "dialer_session_paused",
    // La sequenza di chiamate (piano M5, Task 10a): «Ferma la sequenza» o «Il Lead ha risposto» su una sequenza già finita;
    // «Riparti con la sequenza» con la sequenza in corso o finita per un motivo che non lo ammette (un blocco, un numero errato,
    // esaurita: riparte soltanto dopo una risposta o una fermata a mano, D8).
    "sequence_not_open",
    "sequence_cannot_restart",
    // Il parco dei cellulari dell'ufficio (piano M4, Task 16): chi chiama non ha un cellulare verificato per chiamare; il cellulare
    // è già di un'altra persona, o la persona ne ha già uno; il cellulare non è verificato e non si assegna; il numero non è un
    // cellulare italiano (un fisso, un numero straniero); il numero è già nel parco; il fornitore ha già verificato quel numero
    // per l'azienda, che si porta nel parco con «Leggi i cellulari già verificati» (revisione finale del Task 17).
    "caller_number_missing",
    "caller_number_taken",
    "caller_number_not_verified",
    "caller_number_not_mobile",
    "caller_number_exists",
    "caller_number_already_verified",
    // I Task e i richiami (piano M5, Task 16): il Task non c'è o è fuori dal perimetro di chi chiede; il Lead ha già un richiamo
    // aperto (con il suo identificativo, per «Sposta»); l'orario scelto non è un richiamo valido (con il motivo: passato, giorno
    // chiuso, fuori dagli orari dei richiami, non a quarti d'ora, troppo lontano).
    "task_not_found",
    "task_exists",
    "callback_slot_invalid",
    "appointment_exists",
    "appointment_slot_invalid",
    "appointment_result_too_early",
    // Le Opportunità (piano M6, R8, Task 24): l'Opportunità non c'è o è fuori dal perimetro di chi chiede; il Lead ha già
    // un'Opportunità aperta e quella chiusa non si riapre (con l'identificativo di quella aperta).
    "opportunity_not_found",
    "opportunity_exists",
    // «Registra attività» (piano M5, Task 19): l'ora della telefonata fatta fuori dal CRM non va, con il motivo (nel futuro, prima
    // che il Lead ci fosse).
    "manual_call_invalid",
    // I WhatsApp (piano M6, R1, Task 3): il Lead non riceve WhatsApp, con il motivo (lo status blocca le chiamate, nessun cellulare,
    // «Non inviare WhatsApp»); il numero è già il WhatsApp di un'altra persona (con il suo nome, `holderDisplayName`); il modo
    // scelto per una persona l'azienda non lo usa, o non esiste ancora (in R1 soltanto a mano, questione 404).
    "whatsapp_blocked",
    "whatsapp_number_taken",
    "whatsapp_channel_not_enabled",
    // Il WhatsApp ufficiale di Meta (piano M6, R2, Task 6a; le rotte arrivano dal Task 7a): mancano le variabili dell'app di Meta;
    // il numero non è ancora nell'account WhatsApp Business dell'azienda e serve la finestra di Meta; un passo della registrazione
    // non è riuscito (con il passo); un'altra registrazione dell'azienda è in corso; il numero scelto nella finestra di Meta non è
    // quello scritto; l'account WhatsApp Business scelto non è quello dell'azienda; il Business Manager ha già tutti i numeri che
    // può registrare; Meta non ha ricevuto il modello; il modello comincia o finisce con una variabile (questione 411); il numero
    // del Lead non è fra i numeri ammessi dell'azienda (questione 414); l'account WhatsApp Business scelto è già collegato a
    // un'altra azienda di Gioia365 (Task 9a, decisione del controller); il gettone della finestra di Meta non dà accesso all'account
    // WhatsApp Business mandato dal browser (revisione notturna del 9 ottobre 2026).
    "whatsapp_meta_not_configured",
    "whatsapp_meta_window_required",
    "whatsapp_signup_failed",
    "whatsapp_signup_busy",
    "whatsapp_number_mismatch",
    "whatsapp_waba_mismatch",
    "whatsapp_number_cap_reached",
    "whatsapp_template_not_submitted",
    "whatsapp_template_variable_at_edge",
    "whatsapp_recipient_not_allowed",
    "whatsapp_waba_taken",
    "whatsapp_waba_not_accessible",
    // WhatsApp Agile (piano M6, R9, Task 27a): il tetto dei 2 WhatsApp al giorno allo stesso Lead ferma davvero l'invio da Agile (WA-10:
    // le conferme passano); il codice di Agile non è riconosciuto dal fornitore per quel numero; il codice c'è ma il telefono non risulta
    // collegato (il codice QR non è stato inquadrato); il fornitore non risponde, e il codice non si salva.
    "whatsapp_daily_cap",
    "whatsapp_agile_code_not_recognised",
    "whatsapp_agile_not_paired",
    "whatsapp_agile_unreachable",
    // Impostazioni → «Ingressi dei Lead» (piano dell'ingresso del 10 ottobre 2026, I2, Task 4): «Fai entrare un Lead di prova» c'è
    // soltanto nelle aziende di prova (slug `prova-`).
    "intake_test_unavailable",
    // I moduli di Meta (piano del 12 ottobre 2026, I3, D1): il server non ha Meta; Meta non accetta l'accesso di Facebook (lo scambio
    // del gettone o l'elenco delle pagine); Meta non risponde; la pagina scelta non è fra quelle della persona; Meta non lascia leggere
    // i moduli della pagina; la pagina è già collegata a un'altra azienda di Gioia365.
    "meta_unavailable",
    "meta_login_failed",
    "meta_unreachable",
    "meta_page_not_found",
    "meta_page_forms_unreadable",
    "meta_page_in_use",
    // Il Report (piano M7, Task 2, D3): un «Personalizzato» che arriva dopo oggi o è più lungo di 366 giorni, con il motivo in
    // `details.reason` (`future`, `too_long`).
    "report_period_invalid",
    // L'importazione da Close di ogni sera (INGR-12, 18/10/2026): Close non riconosce la chiave (401), la chiave non legge
    // l'organizzazione (403), Close non risponde alla prova della chiave; manca la chiave; manca una prova a secco finita con la chiave
    // di adesso; un'importazione da Close è già in corso per l'azienda; l'importazione non parte (il motivo in `details.reason`).
    "close_key_rejected",
    "close_key_forbidden",
    "close_unreachable",
    "close_key_missing",
    // La chiave salvata non si decifra più (per esempio `DATA_ENCRYPTION_KEY` cambiata): va salvata di nuovo.
    "close_key_unreadable",
    "close_dry_run_required",
    "close_import_busy",
    "close_import_not_started",
    // La lettura da GoHighLevel (INGR-29, 24/10/2026): GoHighLevel non riconosce il token (401), il token non ha gli ambiti di sola
    // lettura o non è di questa posizione (403), la posizione non esiste, troppe richieste (429), GoHighLevel non risponde; manca la
    // chiave; la chiave salvata non si decifra più.
    "ghl_key_rejected",
    "ghl_key_forbidden",
    "ghl_location_not_found",
    "ghl_rate_limited",
    "ghl_unreachable",
    "ghl_key_missing",
    "ghl_key_unreadable",
    // L'importazione da GoHighLevel (INGR-30, 24/10/2026): una prova o un'importazione già in corso; «Importa adesso» senza una prova a
    // secco finita con la chiave di adesso, o senza i tag confermati per quella prova (INGR-2); la persona owner dei Lead nuovi non è nel
    // Team (una sola, User, attiva); i tag confermati per una prova che non è l'ultima.
    "ghl_import_busy",
    "ghl_dry_run_required",
    "ghl_tags_unconfirmed",
    "ghl_owner_missing",
    "ghl_tags_stale",
    // Non parte mentre gira l'importazione da Close (fra le 21:00 e le 22:05 di Roma o con un'esecuzione in corso).
    "ghl_close_import_running",
    // «Importa adesso» con una prova a secco che non ha letto tutto ciò che GoHighLevel dice di avere; Close che non parte con
    // un'importazione da GoHighLevel viva (INGR-30).
    "ghl_dry_run_incomplete",
    "close_ghl_import_running",
    // La scrittura su GoHighLevel (INGR-19, 29/10/2026): l'interruttore si accende soltanto dopo una «Prova senza scrivere» riuscita con
    // la chiave di adesso; GoHighLevel rifiuta il token per scrivere (401/403: mancano gli ambiti di scrittura).
    "ghl_write_dry_run_required",
    "ghl_write_forbidden",
];
export const apiErrorCodeSchema = z.enum(API_ERROR_CODES);
export const apiErrorSchema = z.object({
    code: apiErrorCodeSchema,
    message: z.string().min(1),
    details: z.record(z.string(), z.unknown()).optional(),
});
//# sourceMappingURL=errors.js.map